import Vue from "vue";
import Vuex from "vuex";

import auth from "./shared/state/auth";
import {
    notifications,
    users,
    templates,
    adminSettings,
    deliveries,
    notificationTemplates,
    mailingAccounts,
    outgoingPhones,
} from "./admin/admin-states";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        notifications,
        users,
        templates,
        adminSettings,
        deliveries,
        notificationTemplates,
        mailingAccounts,
        outgoingPhones,
    },
});
